import { getResources } from 'redux-resource';
import { getStatus }    from 'redux-resource';


export function getGroups(state, businessID) {
  return getResources(state.groups, businessID);
}


function getGroupsReadStatus(state, businessID) {
  return getStatus(state.groups, `requests.read-${businessID}.status`);
}


function getGroupsReadStatusCode(state, businessID) {
  return state.groups.requests[`read-${businessID}`]?.statusCode;
}


export function getGroupsStatuses(state, businessID) {
  return {
    createStatus:   {},
    deleteStatus:   {},
    readStatus:     getGroupsReadStatus(state, businessID),
    readStatusCode: getGroupsReadStatusCode(state, businessID),
    updateStatus:   {}
  };
}

export function getGroup(state, groupID) {
  return getResources(state.groups, [ groupID ])[0];
}
